import { render, staticRenderFns } from "./ProductReportWidgetComponent.vue?vue&type=template&id=00cd59fe&"
import script from "./ProductReportWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./ProductReportWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductReportWidgetComponent.vue?vue&type=style&index=0&id=00cd59fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports